module.exports = __webpack_public_path__ + "img/IMG_1899_L_Foamcore.05ab01b9.jpg";